import styled from "styled-components";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

export const StyledDrawer = styled(SwipeableDrawer)`
  .MuiDrawer-paper {
    width: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;